const enum Month {
    Jan,
    Feb,
    Mar,
    Apr,
    May,
    Jun,
    Jul,
    Aug,
    Sep,
    Oct,
    Nov,
    Dec
}

const enum Weekday {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}

function isNewYearsDay(date: Date): boolean {
    // New Year's Day - not observed when it falls on a Saturday, observed on Monday when it falls on Sunday
    return (date.getMonth() === Month.Jan && 
        ((date.getDate() === 1) || (date.getDate() === 2 && date.getDay() === Weekday.Monday)));
}

function isMLKDay(date: Date): boolean {
    // MLK Day - obsesrved on third Monday of January
    return date.getMonth() === Month.Jan && date.getDay() === Weekday.Monday && date.getDate() >= 15 && date.getDate() <= 21;
}

function isPresidentsDay(date: Date) {
    // President's Day - observed on third Monday of February
    return date.getMonth() === Month.Feb && date.getDay() === Weekday.Monday && date.getDate() >= 15 && date.getDate() <= 21;
}

function isMemorialDay(date: Date) {
    // Memorial Day - observed on the last Monday of May
    return date.getMonth() === Month.May && date.getDay() === Weekday.Monday && date.getDate() >= 25 && date.getDate() <= 31;
}

function isJuneteenth(date: Date) {
    // Juneteenth - June 19th, observed on Friday when it falls on Saturday, observed on Monday when it falls on Sunday
    return date.getMonth() === Month.Jun &&
        ((date.getDate() === 19) ||
         (date.getDate() === 18 && date.getDay() === Weekday.Friday) ||
         (date.getDate() === 20 && date.getDay() === Weekday.Monday));
}

function isIndependenceDay(date: Date) {
    // Independence Day - July 4th, observed on Friday when it falls on Saturday, observed on Monday when it falls on Sunday
    return date.getMonth() === Month.Jul && 
        ((date.getDate() === 4) ||
         (date.getDate() === 3 && date.getDay() === Weekday.Friday) ||
         (date.getDate() === 5 && date.getDay() === Weekday.Monday));
}

function isLaborDay(date: Date) {
    // Labor Day - observed on the first Monday of September
    return date.getMonth() == Month.Sep && date.getDay() === Weekday.Monday && date.getDate() >= 1 && date.getDate() <= 7
}

function isIndigenousPeoplesDay(date: Date) {
    // Indigenous Peoples Day - observed on the second Monday of October
    return date.getMonth() == Month.Oct && date.getDay() === Weekday.Monday && date.getDate() >= 8 && date.getDate() <= 14;
}

function isVeteransDay(date: Date) {
    // Veteran's Day - November 11th, observed on Friday when it falls on Saturday, observed on Monday when it falls on Sunday
    return date.getMonth() == Month.Nov &&
        ((date.getDate() === 11) ||
         (date.getDate() === 10 && date.getDay() === Weekday.Friday) ||
         (date.getDate() === 12 && date.getDay() === Weekday.Monday));
}

function isThanksgiving(date: Date) {
    // Thanksgiving - observed on the fourth Thursday of November
    return date.getMonth() == Month.Nov && date.getDay() === Weekday.Thursday && date.getDate() >= 22 && date.getDate() <= 28;
}

function isChristmas(date: Date) {
    // Christmas - December 25th, observed on Friday when it falls on Saturday, observed on Monday when it falls on Sunday
    return date.getMonth() == Month.Dec &&
        ((date.getDate() === 25) ||
         (date.getDate() === 24 && date.getDay() === Weekday.Friday) ||
         (date.getDate() === 26 && date.getDay() === Weekday.Monday));
}

export function isHoliday(date: Date): boolean {
    // Good Friday - relies on the cycle of the moon, so not implmented here

    return isNewYearsDay(date) ||
        isMLKDay(date) || 
        isPresidentsDay(date) || 
        isMemorialDay(date) || 
        isJuneteenth(date) || 
        isIndependenceDay(date) ||
        isLaborDay(date) ||
        isIndigenousPeoplesDay(date) ||
        isVeteransDay(date) ||
        isThanksgiving(date) ||
        isChristmas(date);
}